@for (address of addressList; track address) {
  <ion-row tappable (click)=changeAddress(address)>
    <ion-col class="button-icon">
      <div class="icon-address"></div>
    </ion-col>
    <ion-col class="button-label">
      <span>{{ address?.address_name || address.address1 }}</span>
    </ion-col>
  </ion-row>
}
<ion-row tappable (click)="goToManageAddresses()" [ngClass]="{'selectedButton': menuData?.route === '/manage-addresses'}">
  <ion-col class="button-icon">
    <div class="icon-gear"></div>
  </ion-col>
  <ion-col class="button-label">
    <span>Manage Addresses</span>
  </ion-col>
</ion-row>
